function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0507813,0,0,0.0507813,2,2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446,40L400,40L400,16C400,7.164 392.837,0 384,0C375.163,0 368,7.164 368,16L368,40L144,40L144,16C144,7.164 136.837,0 128,0C119.163,0 112,7.164 112,16L112,40L66,40C29.607,40 0,69.607 0,106L0,446C0,482.393 29.607,512 66,512L446,512C482.393,512 512,482.393 512,446L512,106C512,69.607 482.393,40 446,40ZM66,72L112,72L112,88C112,96.836 119.163,104 128,104C136.837,104 144,96.836 144,88L144,72L368,72L368,88C368,96.836 375.163,104 384,104C392.837,104 400,96.836 400,88L400,72L446,72C464.748,72 480,87.252 480,106L480,144L32,144L32,106C32,87.252 47.252,72 66,72ZM446,480L66,480C47.252,480 32,464.748 32,446L32,176L480,176L480,446C480,464.748 464.748,480 446,480Z",
    style: {
      fill: "rgb(222,222,222)",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarLight);
export default __webpack_public_path__ + "static/media/calendar-light.af6cf23b6f4b813acd11cdfe60fbf82c.svg";
export { ForwardRef as ReactComponent };